<ng-container *ngIf="error_messages.length > 0">
  <ng-container *ngFor="let error_message of error_messages">
    <div class="alert alert-danger">
      <button type="button" class="close" data-dismiss="alert" (click)="removeErrorMessage(error_message)">
        ×
      </button>
      {{ error_message }}
    </div>
  </ng-container>
</ng-container>

<ng-container
  *ngIf="self_signer != true && redirect == false && error_messages.length == 0 && loading_settings != true"
>
  <section
    role="dialog"
    tabindex="-1"
    class="slds-modal_large"
    aria-labelledby="id-of-modalheader-h2"
    aria-describedby="modal-content-id-1"
  >
    <div class="slds-modal__container">
      <header class="slds-modal__header">
        <h2 id="id-of-modalheader-h2" class="slds-text-heading_medium">Document Sent</h2>
      </header>
      <div class="slds-modal__content slds-grid slds-grow" id="modal-content-id-1">
        <div class="slds-scrollable slds-grow">
          <div class="slds-form slds-form_horizontal left">
            Successfully Sent Document Invite
            <br />
            <br />
            <br />
            <a (click)="back_to_templates_page()" href="javascript:void(0);">Go Back to Start</a>
          </div>
        </div>
      </div>
      <footer class="slds-modal__footer left"></footer>
    </div>
  </section>
</ng-container>

<ng-container *ngIf="self_signer != true && error_messages.length > 0 && redirect == false">
  <section
    role="dialog"
    tabindex="-1"
    class="slds-modal_large"
    aria-labelledby="id-of-modalheader-h2"
    aria-describedby="modal-content-id-1"
  >
    <div class="slds-modal__container">
      <header class="slds-modal__header">
        <h2 id="id-of-modalheader-h2" class="slds-text-heading_medium">Something went wrong</h2>
      </header>
      <div class="slds-modal__content slds-grid slds-grow" id="modal-content-id-1">
        <div class="slds-scrollable slds-grow">
          <div class="slds-form slds-form_horizontal left">
            Please see the error's on this page for more details.
            <br />
            <br />
            <br />
            <a (click)="back_to_templates_page()" href="javascript:void(0);">Go Back to Start</a>
          </div>
        </div>
      </div>
      <footer class="slds-modal__footer left"></footer>
    </div>
  </section>
</ng-container>

<loading
  [loading]="loading_settings == true && error_messages.length == 0"
  [loadingMessage]="loading_setting_message"
></loading>

<loading
  [loading]="redirect == true && error_messages.length == 0"
  [loadingMessage]="loading_redirect_message"
></loading>

<loading
  [loading]="self_signer == true && error_messages.length == 0"
  [loadingMessage]="loading_self_signer"
></loading>
